import ContentTitle from './ContentTitle';

export default ContentTitle;